import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { supplierUrls } from "../../URL/ApplicationUrls";
import Supplier from "../Supplier";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useUpdateSupplier = (supplierId: number | string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (supplier: Supplier) => {
      return axios.put<Supplier>(supplierUrls.updateSupplier.apiUrl, supplier);
    },
    onSuccess: async (response: AxiosResponse<Supplier>) => {
      const supplier = response.data;
      await queryClient.invalidateQueries(namedQueryKeyWithId("suppliers", supplier.Id));
      toast.success(`Updating the supplier with the Id ${supplier.Id} was successful`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
